module.exports = __webpack_public_path__ + "static/media/Termos-Condições-Sócio.9b03cbf0.pdf";